import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { compose } from "recompose";
import { Route, Redirect } from "react-router-dom";
import { withFirebase, isLoaded } from "react-redux-firebase";
import * as routes from "constants/routes";
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import AppIcon from 'assets/avantor-logo.png'

const styles = theme => ({
  wrapper: {
    display: 'flex',
    flex: 1,
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
});


class PrivateRoute extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authUser: null,
    };
  }

  render() {
    const { component: Component, classes, auth, isAuthenticated, ...rest } = this.props;

    if (!isLoaded(auth)) return (
      <div className={classes.wrapper}>
        <CircularProgress className={classes.progress} thickness={6} />
        <div><img width={120} src={AppIcon} alt="avantor"/></div>
      </div>
    )

    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Component {...props} />
          ) : (
            <Redirect
              to={{
                pathname: routes.SIGN_IN,
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  }
}

PrivateRoute.propTypes = {
  auth: PropTypes.object,
  profile: PropTypes.object,
};

const mapStateToProps = state => {

  const { auth, profile, authError } = state.firebase;

  const isAuthenticated = !!auth && !!auth.uid;

  return {
    isAuthenticated: isAuthenticated,
    auth: auth,
    profile: profile,
    authError: authError
  };
};

export default compose(
  withFirebase,
  connect(mapStateToProps),
  withStyles(styles),
)(PrivateRoute);
